import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	placeholder: {
		id: 'software-board-create.modal.form.source-value-picker.team-picker.placeholder',
		defaultMessage: 'Select',
		description: 'Placeholder text for the team picker',
	},
});
